module.exports = __webpack_public_path__ + "img/app1.d168e970.png";